var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.core.js
// module id = 14
// module chunks = 174 178 179 182 193 194 195